
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.5 0C7.85 0 0 7.85 0 17.5S7.85 35 17.5 35 35 27.15 35 17.5 27.15 0 17.5 0zm0 33.654c-8.907 0-16.154-7.247-16.154-16.154S8.593 1.346 17.5 1.346 33.654 8.593 33.654 17.5 26.407 33.654 17.5 33.654z","fill":"#00E5FF"}}),_c('path',{attrs:{"d":"M24.034 10.966a.672.672 0 00-.952 0L17.5 16.548l-5.582-5.582a.672.672 0 10-.952.952l5.582 5.582-5.582 5.582a.672.672 0 10.952.951l5.582-5.581 5.582 5.581a.671.671 0 00.951 0 .672.672 0 000-.951L18.453 17.5l5.581-5.582a.672.672 0 000-.952z","fill":"#00E5FF"}})])
          )
        }
      }
    